<template>
    <div class="calendar-wrap">
        <div class="calendar-wrap-day">
            <div class="table-holder table-responsive">
                <table class="table">
                    <tbody>
                    <tr
                        v-for="event in foundEvents"
                        :key="event.id"
                    >
                        <td style="width:150px">
                            <div class="text-14 color--text-gray">
                                {{ formatDateForSearch(event.start_date) }}
                            </div>
                        </td>
                        <td style="width:200px">
                            <div class="d-flex">
                                <div
                                    class="color mr-2"
                                    :class="'background-color--c' + (event.color)"
                                ></div>
                                {{ formatTimeForSearch(event.start_date) }} - {{ formatTimeForSearch(event.end_date) }}
                            </div>

                        </td>
                        <td style="min-width:300px">
                            <a @click="showCustomModal('event', event.id)">
                                <b> {{ event.title }}</b>
                            </a>
                            <EventInfoModal
                                :modal-id="getCustomModalId('event', event.id)"
                                :event="event"
                                @delete="deleteEvent"
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DateConverter from "../../../../../resources/js/mixins/DateConverter";
import EventInfoModal from "./EventInfoModal.vue";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";
import CalendarService from "./services/CalendarService";

export default {
    name: "CalendarSearch",
    components: {EventInfoModal},
    emits: ['update-list'],
    props: {
        foundEvents: Array
    },
    mixins: [DateConverter, ModalHandler],
    methods: {
        async deleteEvent(eventId) {
            try {
                await CalendarService.deleteEvent(eventId)
                $(`#event-${eventId}`).modal('hide');
                this.$emit('update-list')
                this.$showSuccessMessage('Event was deleted')
            } catch (e) {
                this.$showErrorMessage('Your event was not deleted')
            }
        },
    }
}

</script>


<style scoped>


</style>
